/*
    Developer Name : Raja
    Created Date : 17-09-2021
    Page Name      : Genaric File Export Service
    Description    : table export in csv and excel formats
    Modified By    :
    Modified Date  :
    Modified       :
*/
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ngxCsv } from 'ngx-csv/ngx-csv';
import { DateService } from '../../../../@theme/components/common/service/date.service';
import { JsonPipe } from '@angular/common';
// import * as CryptoJS from 'crypto-js';
import { Angular5Csv } from 'angular5-csv/dist/Angular5-csv';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx-js-style';
import * as ExcelJS from 'exceljs';
// import { ExportAsService, ExportAsConfig, SupportedExtensions } from 'ngx-export-as';
const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';
import { AsyncSubject } from 'rxjs';

export interface SelectedFiles {
  name: string;
  file: any;
  base64?: string;
  url?: string;
}

/** Column definition for exportTypedWorkbook - `type` decides the real Excel cell type/format:
 * 'currency' / 'number' -> numeric cells, 'date' / 'datetime' -> real Excel date cells, 'id' / 'text' ->
 * text (so identifiers are never treated as numbers/amounts). */
export interface TypedExcelColumn {
  header: string;
  key: string;
  type?: 'text' | 'id' | 'number' | 'currency' | 'date' | 'datetime';
  width?: number;
  /** Excel number format override for 'number' columns (default '0.####'). */
  numFmt?: string;
}

export interface TypedExcelSheet {
  name: string;
  /** Label/value lines written above the table (e.g. report title, patient details, generated on). */
  metaRows?: Array<Array<string | number | Date>>;
  columns: TypedExcelColumn[];
  rows: any[];
  /** Optional bold totals row under the table, keyed by column key. */
  totalsRow?: Record<string, any>;
}

@Injectable({
  providedIn: 'root'
})
export class FileExportService {
  objectWithHighestLength: number;

  constructor(public dateServices:DateService) { }

  exportbillReport(type, data, header, filename) {
    if (type == "CSV") {
      // this.startexportCSV(data,header,filename)
      var options = {
        fieldSeparator: ',',
        quoteStrings: '"',
        decimalseparator: '.',
        showLabels: true,
        showTitle: false,
        title: filename,
        useBom: true,
        noDownload: false,
        headers: header
      };
      new ngxCsv(data, filename, options);

    } else {
      this.ExportasExcelfile(data, filename);
    }
  }

  public ExportasExcelfile(json, fileName: string): void {
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json, {
      header: [],
      skipHeader: true,
    });

    var wscols = [
      { width: 17 },
      { width: 25 },
      { width: 27 },
    ];

    ws['!cols'] = wscols;

    if(fileName == "OP-bill-list"){
      var wscols = [
        { width: 15 },
        { width: 18 },
        { width: 20 },
        { width: 15 },
        { width: 10 },
        { width: 15 },
        { width: 15 },
        { width: 20 },
      ];

      ws['!cols'] = wscols;
    }


    if(fileName == "Purchase-list" || fileName == "Outside-Lab-Work-Order-List"){
      var wscols = [
        { width: 10 },
        { width: 15 },
        { width: 25 },
        { width: 20  },
        { width: 20 },
        { width: 18 },
        { width: 20 }
      ];

      ws['!cols'] = wscols;
    }
 if (fileName == "Blood-Stock-Detail") {
      var wscols = [
        { width: 15 },
        { width: 18 },
        { width: 20 },
        { width: 15 },
        { width: 10 },
        { width: 15 },
        { width: 15 },
        { width: 20 },
        { width: 18 },
      ];

      ws['!cols'] = wscols;
    }
    if (fileName == "Blood-Collection-List") {
      var wscols = [
        { width: 15 },
        { width: 18 },
        { width: 20 },
        { width: 15 },
        { width: 10 },
        { width: 15 },
        { width: 15 },
        { width: 20 },

      ];

      ws['!cols'] = wscols;
    }
    if (fileName == "Blood-Current-Stock" || fileName == "Supplier-Payment-list") {
      var wscols = [
        { width: 15 },
        { width: 18 },
        { width: 20 },
        { width: 15 },

      ];

      ws['!cols'] = wscols;
    }

    if (fileName == "Blood-Indent-Return") {
      var wscols = [
        { width: 15 },
        { width: 50 },
        { width: 50 },
        { width: 15 },

      ];

      ws['!cols'] = wscols;
    }
    if (fileName == "Blood-Discard-Details" ||fileName == "payment") {
      var wscols = [
        { width: 15 },
        { width: 20 },
        { width: 20 },
        { width: 15 },
        { width: 20 },
        { width: 25 },

      ];

      ws['!cols'] = wscols;
    }

    if (fileName == "Sales-tax-Report-list") {
      var wscols = [
        { width: 15 },
        { width: 20 },
        { width: 20 },
        { width: 15 },
        { width: 20 },
        { width: 25 },
        { width: 20 },
        { width: 25 },

      ];

      ws['!cols'] = wscols;
    }

    if (fileName == "Blood-donor-Details") {
      var wscols = [
        { width: 15 },
        { width: 20 },
        { width: 20 },
        { width: 15 },
        { width: 20 },
        { width: 25 },
        { width: 15 },
        { width: 20 },
        { width: 25 },
        { width: 15 },
        { width: 20 },
        { width: 25 },

      ];

      ws['!cols'] = wscols;
    }

    if (fileName == "Blood-Opening-stock") {
      var wscols = [
        { width: 15 },
        { width: 20 },
        { width: 20 },
        { width: 15 },
        { width: 20 },
        { width: 25 },
        { width: 20 },
        { width: 20 },

      ];

      ws['!cols'] = wscols;
    }
    if (fileName == "Blood-indent-request" || fileName == "warranty" || fileName == "Attachments") {
      var wscols = [
        { width: 15 },
        { width: 20 },
        { width: 20 },
        { width: 15 },
        { width: 20 },


      ];

      ws['!cols'] = wscols;
    }
    if (fileName == "Blood-indent-approval") {
      var wscols = [
        { width: 15 },
        { width: 20 },
        { width: 20 },
        { width: 15 },
        { width: 20 },


      ];

      ws['!cols'] = wscols;
    }
    if (fileName == "Blood-indent-issue") {
      var wscols = [
        { width: 15 },
        { width: 20 },
        { width: 20 },
        { width: 15 },
        { width: 20 },


      ];

      ws['!cols'] = wscols;
    }
    if (fileName == "Blood-indent-receive") {
      var wscols = [
        { width: 15 },
        { width: 20 },
        { width: 20 },
        { width: 15 },
        { width: 20 },


      ];

      ws['!cols'] = wscols;
    }


    if (fileName == "Blood-Bank-transfusion-list") {
      var wscols = [
        { width: 15 },
        { width: 20 },
        { width: 20 },
        { width: 15 },
        { width: 20 },
        { width: 25 },
        { width: 15 },
        { width: 20 },
        { width: 25 },
        { width: 15 },
        { width: 20 },
        { width: 25 },


      ];

      ws['!cols'] = wscols;
    }
    if (fileName == "Lab-result-List") {
      var wscols = [
        { width: 15 },
        { width: 20 },
        { width: 20 },
        { width: 15 },
        { width: 20 },
        { width: 25 },
        { width: 15 },
        { width: 20 },


      ];

      ws['!cols'] = wscols;
    }
    if (fileName == "Open-Stock-list") {
      var wscols = [
        { width: 20 },
        { width: 20 },
        { width: 10 },
        { width: 15 },
        { width: 10 },
        { width: 10 },
        { width: 13 },
        { width: 10 },
        { width: 10 },
        { width: 15 },
        { width: 14 },
        { width: 10 },
      ];

      ws['!cols'] = wscols;
    }


    if (fileName == "Pharmacy-Detailed-Credit-Bill-List" || fileName == "Purchase-Return-list" || fileName=="Sales-Return-list") {
      var wscols = [
        { width: 15 },
        { width: 15 },
        { width: 15 },
        { width: 20 },
        { width: 15 },
        { width: 20 },
        { width: 18 },
        { width: 15 },
        { width: 15 },
        { width: 17 }
      ];

      ws['!cols'] = wscols;
    }
    if (fileName == "Radiology-Work-Order-List" )  {
      var wscols = [
        { width: 15 },
        { width: 20 },
        { width: 15 },
        { width: 20 },
        { width: 20 },
        { width: 15 }
      ];
      ws['!cols'] = wscols;
    }



    if (fileName == "Pharmacy-Consolidated-Credit-Bill-Listt" ||fileName == "service" ) {
      var wscols = [
        { width: 10 },
        { width: 15 },
        { width: 15 },
        { width: 15 },
        { width: 15 },
        { width: 15 },
        { width: 15 },
      ];

      ws['!cols'] = wscols;
    }

    if ( fileName == "Supplier-Dues-list") {
      var wscols = [
        { width: 20 },
        { width: 20 },
        { width: 25 },
        { width: 15 },
        { width: 20 },


      ];

      ws['!cols'] = wscols;
    }



    for (var i in ws) {
      if (typeof ws[i] != 'object') continue;
      let cell = XLSX.utils.decode_cell(i);

      ws[i].s = {
        // styling for all cells
        font: {
          name: 'Tahoma',
          sz: "10"
        },
        alignment: {
          vertical: 'center',
          horizontal: 'center',
          wrapText: '1', // any truthy value here
        },

      };


      if (cell.r == 3 || cell.r == 0) {
        ws[i].s = {
          // styling for all cells
          font: {
            name: 'Tahoma',
            sz: "10",
            bold: true,
          },
          alignment: {
            vertical: 'center',
            horizontal: 'center',
            wrapText: '1', // any truthy value here
          },
        };
      }

      if (cell.r >= 4) {
        ws[i].s = {
          border: {
            right: {
              style: 'thin',
              color: '000000',
            },
            left: {
              style: 'thin',
              color: '000000',
            }
          },
          alignment: {
            vertical: 'center',
            horizontal: 'center',
            wrapText: '1'
          }
        }
      }
      if(fileName=="Radiology-Work-Order-List" ){
        if (cell.r >= 5) {
          ws[i].s = {
            border: {
              right: {
                style: 'thin',
                color: '000000',
              },
              left: {
                style: 'thin',
                color: '000000',
              }
            },
            alignment: {
              vertical: 'center',
              horizontal: 'center',
              wrapText: '1'
            }
          }
        }
        if (cell.r == 4) {
          ws[i].s = {
            // styling for all cells
            font: {
              name: 'Tahoma',
              sz: "10",
              bold: true,
            },
            alignment: {
              vertical: 'center',
              horizontal: 'center',
              wrapText: '1', // any truthy value here
            },
          };
        }
      }

    }
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, fileName+ EXCEL_EXTENSION);
  }


  newExcelExport(type, data, header, filename) {

    this.objectWithHighestLength = 0;
    for (const obj of data) {
      if (obj && typeof obj === 'object') {
        const objKeysLength = Object.keys(obj)?.length;
        if (objKeysLength > this.objectWithHighestLength) {
          this.objectWithHighestLength = objKeysLength;
        }
      }
    }

    let exportData = [];

    let dateObj:any={
    }
    if(filename=="Lab Statistical Report (Patients Count)"){
       exportData = [
        {
          0: localStorage.getItem("hospitalName")
        },
        {
          0:  "Mobile No.: " +localStorage.getItem("HospitalMobile")
        },
        {
          0: localStorage.getItem("HospitalAddress")
        },
      ];
      for (let i = 1; i <= 50; i++) {
        dateObj[i]="";
      }
      var date = this.dateServices.dateUtctoLocal(new Date(), 'DD-MM-YYYY h:mm:ss a');
      dateObj[0]=filename;
      dateObj[(this.objectWithHighestLength-2)]="Print Date and Time";
      dateObj[(this.objectWithHighestLength-1)]=date;
      exportData.push(dateObj);
      data.reduce((obj,item) => {
        exportData.push(item);
      }, {});
    
    }else{
       exportData = [
        {
          value1: localStorage.getItem("hospitalName")
        },
        {
          value1:  "Mobile No.: " +localStorage.getItem("HospitalMobile")
        },
        {
          value1: localStorage.getItem("HospitalAddress")
        },
      ];
      for (let i = 1; i <= 50; i++) {
        dateObj["value"+(i)]="";
      }
      var date = this.dateServices.dateUtctoLocal(new Date(), 'DD-MM-YYYY h:mm:ss a');
      if(this.objectWithHighestLength==2 ||this.objectWithHighestLength==3){
        dateObj["value1"]=filename;
        dateObj["value3"]="Print Date and Time";
        dateObj["value4"]=date;
      }else if(this.objectWithHighestLength==1){
          dateObj["value1"]=filename;
          dateObj["value2"]="Print Date and Time";
          dateObj["value3"]=date;
      }
      else{
        dateObj["value1"]=filename;
        dateObj["value"+(this.objectWithHighestLength-1)]="Print Date and Time";
        dateObj["value"+(this.objectWithHighestLength)]=date;
      }
      exportData.push(dateObj);
      data.reduce((obj,item) => {
        exportData.push(item);
      }, {});
    }
 

    if (type == "CSV") {
      // this.startexportCSV(data,header,filename)
      var options = {
        fieldSeparator: ',',
        quoteStrings: '"',
        decimalseparator: '.',
        showLabels: true,
        showTitle: false,
        title: filename,
        useBom: true,
        noDownload: false,
        headers: header
      };
      new ngxCsv(exportData, filename, options);

    } else {
      this.newExportExcelReport(exportData, filename);
    }
  }

  public newExportExcelReport(json, fileName: string): void{
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json, {
      header: [],
      skipHeader: true,
    });
    var wscols = [
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 22 },
      { width: 15 },
      { width: 15 },
      { width: 15 },
      { width: 15 },
      { width: 15 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 22 },
      { width: 15 },
      { width: 15 },
      { width: 15 },
      { width: 15 },
      { width: 15 }
    ];
    ws['!cols'] = wscols;
    if ( fileName == "Sales HSN Wise Report" || fileName == "Sales Return HSN Wise Report" || fileName == "Detailed Stock Report" || fileName == "Sales Sold Out Medicine Report" || fileName == "OP-Service-Wise-Report" || fileName =="Sales Pofit And Loss Report" || fileName=="Pharmacy-Purchase-Tax-Report-List" || fileName=="OT Ledger Report")  {
      var wscols = [
        { width: 20 },
        { width: 20 },
        { width: 20 },
        { width: 20 },
        { width: 20 },
        { width: 22 },
        { width: 20 },
        { width: 20 },
        { width: 20 },
        { width: 20 },
        { width: 25 }
      ];
      ws['!cols'] = wscols;
    }

    if (fileName == "Open-Stock-list" || fileName == "Location-Wise-stock-List" || fileName == "Warehouse-Wise-stock-List") {
      var wscols = [
        { width: 20 },
        { width: 20 },
        { width: 10 },
        { width: 15 },
        { width: 10 },
        { width: 20 },
        { width: 13 },
        { width: 10 },
        { width: 10 },
        { width: 15 },
        { width: 14 },
        { width: 10 },
      ];

      ws['!cols'] = wscols;
    }

    if (fileName == "Consolidated Purchase GST Report" || fileName == "Consolidated PurchaseReturn GST Report" ||fileName == "Consolidated Sales GST Report" ||fileName == "Consolidated Sales Return GST Report") {
      var wscols = [
        { width: 15 },
        { width: 20 },
        { width: 15 },
        { width: 15 },
        { width: 15 },
        { width: 15 },
        { width: 20 },
        { width: 15 },
        { width: 15 },
        { width: 15 },
        { width: 15 },
        { width: 15 },
        { width: 15 },
        { width: 15 },
        { width: 15 },
        { width: 15 },
        { width: 15 },
        { width: 15 },
        { width: 15 },
        { width: 15 },
        { width: 15 },
        { width: 15 },
      ];
      ws['!cols'] = wscols;
    }

    if (fileName == "Detail Purchase GST Report" || fileName == "Detail PurchaseReturn GST Report" ||fileName == "Detail Sales GST Report"|| fileName == "Detail Sales Return GST Report") {
      var wscols = [
        { width: 15 },
        { width: 20 },
        { width: 15 },
        { width: 15 },
        { width: 15 },
        { width: 15 },
        { width: 20 },
        { width: 15 },
        { width: 15 },
        { width: 15 },
        { width: 15 },
        { width: 15 },
        { width: 15 },
        { width: 15 },
        { width: 15 },
        { width: 15 },
        { width: 15 },
        { width: 15 },
        { width: 15 },
        { width: 15 },
        { width: 15 },
        { width: 15 },
        { width: 15 },
        { width: 15 },
        { width: 15 },
        { width: 15 },
        { width: 15 },
        { width: 15 },
        { width: 15 },
        { width: 15 },
        { width: 15 },
        { width: 15 },
        { width: 15 },
        { width: 15 },
        { width: 15 },
        { width: 15 },
        { width: 15 },
        { width: 15 },
        { width: 15 },
        { width: 15 },
        { width: 15 },
        { width: 15 },
        { width: 15 },
        { width: 15 },
        { width: 15 },
        { width: 15 },
        { width: 15 }
      ];
      ws['!cols'] = wscols;
    }
    if (fileName == "OP-Service-Wise-Report") {
      var wscols = [
        { width: 15 },
        { width: 15 },
        { width: 15 },
        { width: 15 },
        { width: 15 },
        { width: 15 },
        { width: 20 },
        { width: 15 },
        { width: 15 },
        { width: 15 },
        { width: 20 },
        { width: 20 },
        { width: 20 },
        { width: 20 }
      ];

      ws['!cols'] = wscols;
    }
    if (fileName == "Doctor-Investigation-Revenue-list" || "Bank-Master" || "Custodian" ||fileName == "AMC" || fileName == "Lease") {
      var wscols = [
        { width: 15 },
        { width: 15 },
        { width: 15 },
        { width: 20 },
        { width: 15 },
        { width: 22 },
        { width: 22 },
        { width: 20 }
      ];

      ws['!cols'] = wscols;
    }

    if ( fileName == "Inpatient-List-Payer-Wise" || "Bank-Location-Mapping-Master") {
      var wscols = [
        { width: 10 },
        { width: 25 },
        { width: 30 },
        { width: 25 },
        { width: 30 },
        { width: 30 },
        { width: 25 }
      ];

      ws['!cols'] = wscols;
    }

    if ( fileName == "Patient Log Management System") {
      var wscols = [
        { width: 10 },
        { width: 25 },
        { width: 30 },
        { width: 35 },
        { width: 35 },
        { width: 20 },
        { width: 20 },
        { width: 20 },
        { width: 20 }
      ];

      ws['!cols'] = wscols;
    }
    

    if ( fileName == "Psychology Report") {
      var wscols = [
        { width: 10 },
        { width: 10 },
        { width: 30 },
        { width: 25 },
        { width: 30 },
        { width: 30 },
        { width: 25 },
        { width: 35 },
        { width: 30 }
      ];

      ws['!cols'] = wscols;
    }

    if ( fileName == "Bill-Collection-Day-wise" || fileName =="asset-missing-found") {
      var wscols = [
        { width: 20 },
        { width: 25 },
        { width: 25 },
        { width: 25}
      ];

      ws['!cols'] = wscols;
    }

    if ( fileName == "Case-Sheet-Template-Master") {
      var wscols = [
        { width: 20 },
        { width: 20 },
        { width: 20 },
        {width: 35},
      ];

      ws['!cols'] = wscols;
    }

    if ( fileName == "Bill-Collection-Service-Category-wise-Report" || fileName == "HMS-Location-Master") {
      var wscols = [
        { width: 25 },
        { width: 20 },
        { width: 20 },
        { width: 20}
      ];

      ws['!cols'] = wscols;
    }

    if ( fileName == "OP-Due-Report") {
      var wscols = [
        { width: 25 },
        { width: 15 },
        { width: 15 },
        { width: 25},
        { width: 25},
        { width: 15},
        { width: 15},
        { width: 15},
        { width: 15},
        { width: 15},
      ];

      ws['!cols'] = wscols;
    }

    if ( fileName == "OP-Service-Grouped-Report") {
      var wscols = [
        { width: 40 },
        { width: 15 },
        { width: 20 },
        { width: 25},
        { width: 25},
        { width: 15},
        { width: 15}
      ];

      ws['!cols'] = wscols;
    }

    if ( fileName == "Package vs Non-Package Service Report") {
      var wscols = [
        { width: 40 },
        { width: 15 },
        { width: 20 },
        { width: 25},
        { width: 25},
        { width: 25},
        { width: 20}
      ];

      ws['!cols'] = wscols;
    }

    if ( fileName == "Service-subCategory") {
      var wscols = [
        { width: 20 },
        { width: 20 },
        { width: 20 },
        { width: 20},
        {width: 30}
      ];

      ws['!cols'] = wscols;
    }

    if ( fileName == "Patient Data Report") {
      var wscols = [
        { width: 20 },
        { width: 20 },
        { width: 20 },
        { width: 10 },
        { width: 20 },
        { width: 15 },
        { width: 15 },
        { width: 10 },
        { width: 10 },
        { width: 10 },
        { width: 25 },
        { width: 25 },
        { width: 25 },
        { width: 25 },
        { width: 25 },
        { width: 25 },
        { width: 25 },
        { width: 25 },
      ];

      ws['!cols'] = wscols;
    }

        if ( fileName == "HealQ Report") {
      var wscols = [
        { width: 20 },
        { width: 30 },
        { width: 20 },
        { width: 15 },
        { width: 15 },
        { width: 15 },
        { width: 20 },
        { width: 20 },
        { width: 20 },
      ];

      ws['!cols'] = wscols;
    }

    if ( fileName == "Appointment-List") {
      var wscols = [
        { width: 25 },
        { width: 10 },
        { width: 15 },
        { width: 15 },
        { width: 15 },
        { width: 25 },
        { width: 20 },
        { width: 20 },
        { width: 20 },
        { width: 20 },
        { width: 25 }
      ];

      ws['!cols'] = wscols;
    }

    if ( fileName == "Appointment List") {
      var wscols = [
        { width: 10 },
        { width: 25 },
        { width: 15 },
        { width: 15 },
        { width: 15 },
        { width: 25 },
        { width: 20 },
        { width: 20 },
        { width: 20 },
        { width: 20 },
        { width: 25 }
      ];

      ws['!cols'] = wscols;
    }



    // Define the columns to merge and center
    const mergeAndCenterColumns = [
      { s: { r: 0, c: 0 }, e: { r: 0, c: (this.objectWithHighestLength-1) } },
      { s: { r: 1, c: 0 }, e: { r: 1, c: (this.objectWithHighestLength-1) } },
      { s: { r: 2, c: 0 }, e: { r: 2, c: (this.objectWithHighestLength-1) } },
      { s: { r: 3, c: 0 }, e: { r: 3, c: (this.objectWithHighestLength/2) } },
      { s: { r: 4, c: 0 }, e: { r: 4, c: (this.objectWithHighestLength-1) } }
      // Merge and center columns 1 and 2
    ];
 // Apply the merge and center formatting
    ws['!merges'] = mergeAndCenterColumns;




    const totalRowRange = XLSX.utils.decode_range(ws['!ref']); 
    let netTotalRowIdx = -1; 
    for (let R = totalRowRange.e.r; R >= 0; R--) { // Karthi
      const firstCell = ws[XLSX.utils.encode_cell({ r: R, c: 0 })]; // Karthi
      if (firstCell && String(firstCell.v).trim().toLowerCase() === 'grand total') { netTotalRowIdx = R; break; } // Karthi
    }

    for (var i in ws) {
      if (typeof ws[i] != 'object') continue;
      let cell = XLSX.utils.decode_cell(i);
    if (cell.r >= 6) {
      ws[i].s = {
        border: {
          right: {
            style: 'thin',
            color: '000000',
          },
          left: {
            style: 'thin',
            color: '000000',
          }
        },
        alignment: {
          vertical: 'center',
          horizontal: 'center',
          wrapText: '1'
        }
      }
    }

    
    if (cell.r == 4 || cell.r == 0|| cell.r == 1 ||  cell.r ==2 || cell.r == 6) {
      ws[i].s = {
        // styling for all cells
        font: {
          name: 'Tahoma',
          sz: "10",
          bold: true,
        },
        alignment: {
          vertical: 'center',
          horizontal: 'center',
          wrapText: '1', // any truthy value here
        },
      };
    }
    if (cell.r == 3 ||cell.r == 0|| cell.r == 1 ||  cell.r == 2 ) {
      ws[i].s = {
        // styling for all cells
        font: {
          name: 'Tahoma',
          sz: "11",
          bold: true,
        },
        alignment: {
          vertical: 'center',
          horizontal: 'center',
          wrapText: '1', // any truthy value here
        },
      };
    }
    if (cell.r == 3 && cell.c == 0) {
      ws[i].s = {
        // styling for all cells
        font: {
          name: 'Tahoma',
          sz: "11",
          bold: true,
        },
        alignment: {
          vertical: 'center',
          horizontal: 'left',
          wrapText: '1', // any truthy value here
        },
      };
    }
    if (netTotalRowIdx >= 0 && cell.r === netTotalRowIdx) { 
      ws[i].s = { ...(ws[i].s || {}), font: { name: 'Tahoma', sz: "10", bold: true } };
      if (typeof ws[i].v === 'number') { 
        ws[i].z = '#,##0.00'; 
        ws[i].s = { ...ws[i].s, numFmt: '#,##0.00' };
        ws['!cols'] = ws['!cols'] || []; 
        ws['!cols'][cell.c] = { width: 22 }; 
      }
    }
  }
  const wb: XLSX.WorkBook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
  XLSX.writeFile(wb, fileName+ EXCEL_EXTENSION);
  }

  fileExport(type,data,header,filename){
    if(type=="CSV"){
      // this.startexportCSV(data,header,filename)
      var options = {
        fieldSeparator: ',',
        quoteStrings: '"',
        decimalseparator: '.',
        showLabels: true,
        showTitle: false,
        title: filename,
        useBom: true,
        noDownload: false,
        headers: header
      };
      new ngxCsv(data, filename ,options);

    }else{
      this.exportAsExcelFile(data,filename);
    }
  }

startexportCSV(data, header, filename) {
    let csvData = this.ConvertToCSV(data, header);
    // console.log(csvData)
    let blob = new Blob(['\ufeff' + csvData], { type: 'text/csv;charset=utf-8;' });
    let dwldLink = document.createElement("a");
    let url = URL.createObjectURL(blob);
    let isSafariBrowser = navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1;
    if (isSafariBrowser) {  //if Safari open in new window to save file with random filename.
        dwldLink.setAttribute("target", "_blank");
    }
    dwldLink.setAttribute("href", url);
    dwldLink.setAttribute("download", filename + ".csv");
    dwldLink.style.visibility = "hidden";
    document.body.appendChild(dwldLink);
    dwldLink.click();
    document.body.removeChild(dwldLink);
}

ConvertToCSV(objArray, headerList) {
     let array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
     let str = '';
     let row = 'S.No,';
     for (let index in headerList) {
         row += headerList[index] + ',';
     }
     row = row.slice(0, -1);
     str += row + '\r\n';
     for (let i = 0; i < array.length; i++) {
         let line = (i+1)+'';
         for (let index in headerList) {
            let head = headerList[index];

             line += ',' + array[i][head];
         }
         str += line + '\r\n';
     }
     return str;
 }


  // export xlxs
  public exportAsExcelFile(json: any[], excelFileName: string): void {
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }
  private saveAsExcelFile(buffer: any, fileName: string): void {
     const data: Blob = new Blob([buffer], {type: EXCEL_TYPE});
     FileSaver.saveAs(data, fileName + '_export_' + new  Date().getTime() + EXCEL_EXTENSION);
  }
// Export text

public exportAsReportExcelFile(json, fileName: string): void {
  const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json, {
    header: [],
    skipHeader: true,
  });

  var wscols = [
    { width: 18 },
    { width: 15 },
    { width: 25 },

    { width: 15 },
    { width: 10 },
    { width: 5 },
  ];

  worksheet['!cols'] = wscols;
  //add styles
  //this.setStyles(fileName);

  const workbook: XLSX.WorkBook = {
    Sheets: { data: worksheet },
    SheetNames: ['data'],
  };
  workbook.Sheets.data.A2.s = { font: { bold: true } };
  if(fileName=="QcReason"){
  workbook.Sheets.data.A1.s = { font: { bold: true } };
  workbook.Sheets.data.A4.s = { font: { bold: true } };
  workbook.Sheets.data.B2.s = { font: { bold: true } };
  workbook.Sheets.data.B4.s = { font: { bold: true } };
  }

  const excelBuffer: any = XLSX.write(workbook, {
    bookType: 'xlsx',
    type: 'array',
  });
  this.saveAsExcelFile(excelBuffer, fileName);
}


/**
 * Generic typed workbook export (ExcelJS - already used by other report exports in this app): real numeric
 * and date cells, bold header row, auto filter, frozen header and column widths. Unlike the json_to_sheet
 * based methods above, values are never stringified, so amounts/quantities stay summable in Excel.
 */
public exportTypedWorkbook(fileName: string, sheets: TypedExcelSheet[]): Promise<void> {
  const workbook = new ExcelJS.Workbook();
  workbook.created = new Date();
  const CURRENCY_FMT = '#,##0.00';
  const DATE_FMT = 'dd-mmm-yyyy';
  const DATETIME_FMT = 'dd-mmm-yyyy hh:mm AM/PM';

  sheets.forEach(sheet => {
    const ws = workbook.addWorksheet(sheet.name);
    const colCount = sheet.columns.length;

    (sheet.metaRows || []).forEach((meta, i) => {
      const row = ws.addRow(meta);
      if (i === 0) { row.font = { bold: true, size: 13 }; }
      row.eachCell(cell => {
        if (cell.value instanceof Date) {
          const d = cell.value;
          cell.value = new Date(d.getTime() - d.getTimezoneOffset() * 60000);
          cell.numFmt = DATETIME_FMT;
          cell.alignment = { horizontal: 'left' };
        }
      });
    });
    if ((sheet.metaRows || []).length > 0) { ws.addRow([]); }

    const headerRow = ws.addRow(sheet.columns.map(c => c.header));
    headerRow.font = { bold: true };
    headerRow.alignment = { vertical: 'middle', wrapText: true };
    headerRow.eachCell(cell => {
      cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFEDE7F6' } };
      cell.border = { bottom: { style: 'thin' } };
    });
    const headerRowNumber = headerRow.number;

    const writeValue = (cell: ExcelJS.Cell, col: TypedExcelColumn, value: any) => {
      if (value === null || value === undefined || value === '') { cell.value = null; return; }
      switch (col.type) {
        case 'currency':
          cell.value = Number(value) || 0; cell.numFmt = CURRENCY_FMT; break;
        case 'number':
          cell.value = Number(value) || 0; cell.numFmt = col.numFmt || '0.####'; break;
        case 'date':
        case 'datetime': {
          const d = value instanceof Date ? value : new Date(value);
          if (isNaN(d.getTime())) { cell.value = String(value); break; }
          // ExcelJS writes Date values as UTC serials - shift so the cell shows the same local wall-clock
          // time the app displays.
          cell.value = new Date(d.getTime() - d.getTimezoneOffset() * 60000);
          cell.numFmt = col.type === 'date' ? DATE_FMT : DATETIME_FMT;
          break;
        }
        default:
          cell.value = String(value);
      }
    };

    sheet.rows.forEach(r => {
      const row = ws.addRow([]);
      sheet.columns.forEach((col, i) => writeValue(row.getCell(i + 1), col, r[col.key]));
    });
    const lastDataRow = ws.lastRow ? ws.lastRow.number : headerRowNumber;

    if (sheet.totalsRow) {
      const row = ws.addRow([]);
      sheet.columns.forEach((col, i) => {
        const v = sheet.totalsRow[col.key];
        if (v !== undefined) { writeValue(row.getCell(i + 1), typeof v === 'number' ? col : { ...col, type: 'text' }, v); }
      });
      row.font = { bold: true };
      row.eachCell(cell => { cell.border = { top: { style: 'thin' } }; });
    }

    sheet.columns.forEach((col, i) => {
      ws.getColumn(i + 1).width = col.width || Math.max(12, Math.min(40, col.header.length + 4));
    });
    // Meta labels live in column A - keep it wide enough to read without resizing.
    if ((sheet.metaRows || []).length > 0 && (ws.getColumn(1).width || 0) < 22) { ws.getColumn(1).width = 22; }

    ws.autoFilter = { from: { row: headerRowNumber, column: 1 }, to: { row: Math.max(lastDataRow, headerRowNumber), column: colCount } };
    ws.views = [{ state: 'frozen', xSplit: 0, ySplit: headerRowNumber }];
  });

  return workbook.xlsx.writeBuffer().then(buffer => {
    FileSaver.saveAs(new Blob([buffer], { type: EXCEL_TYPE }), fileName + EXCEL_EXTENSION);
  });
}

public toBase64(files: File[],selectedFiles: SelectedFiles[]): AsyncSubject<SelectedFiles[]> {
  const result = new AsyncSubject<SelectedFiles[]>();
  if (files?.length) {
    Object.keys(files)?.forEach((file, i) => {
      const url = URL.createObjectURL(files[i]);
      const reader = new FileReader();
      reader.readAsDataURL(files[i]);
      reader.onload = (e) => {
        selectedFiles = selectedFiles?.filter(
          (f) => f?.name != files[i]?.name
        );
        selectedFiles.push({
          name: files[i]?.name,
          file: files[i],
          base64: reader?.result as string,
          url: url,
        });
        result.next(selectedFiles);
        if (files?.length === i + 1) {
          result.complete(); // Hoàn tất toàn bộ quá trình convert, trả về mảng selectedFiles có chứa base64
        }
      };
    });
    return result;
  } else {
    result.next([]);
    result.complete();
    return result;
  }
}

}
